import { Switch, Flex, Typography, Field } from 'shared';

import { useAddNotePostToFeedSectionConfig } from 'features/journal';

export const JournalAddNoteFormPostToFeedSection = () => {
  const { checked, onChange } = useAddNotePostToFeedSectionConfig();

  return (
    <Field>
      <Flex alignItems="center" gap="0.5rem">
        <Typography as="label" color="black" fontWeight="medium" type="meta">
          Post to feed
        </Typography>
        <Switch checked={checked} onChange={onChange} size="lg" />
      </Flex>
    </Field>
  );
};
